// extracted by mini-css-extract-plugin
export default {"root":"AspectRatio_root__JTJ4j","wrapper":"AspectRatio_wrapper__oIMeg","inner":"AspectRatio_inner__Bf+Qw"};